import { useSelector } from "react-redux";
import { selectCurrentUser } from "../store/auth.duck";
import { selectAllTeams, selectHasGlobalConfigLoaded } from "../store/config.duck";
import { isCompanyAdminUser } from '@shared/utils/AccessControl';

export function ShowOnboarding() {
  const current = useSelector(selectCurrentUser);
  const hasGlobalConfigLoaded = useSelector(selectHasGlobalConfigLoaded);
  const teams = useSelector(selectAllTeams);

  return hasGlobalConfigLoaded && isCompanyAdminUser(current) && teams.length === 0;
}
